var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f07662;}.cls-2{fill:#f39889;}.cls-3{fill:#e5e5e5;}.cls-4{fill:#e4e7ef;}.cls-5{fill:#90a6be;}.cls-6{fill:#adb5c1;}.cls-7{fill:#ccc;}.cls-8{fill:#4a535a;}.cls-9{fill:none;mask:url(#mask);}.cls-10{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 78.75,
    y: 82.68,
    width: 7.59,
    height: 17.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-10",
    points: "78.75 82.68 86.34 82.68 86.34 100 78.75 100 78.75 82.68"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Axa.be-Fixico-_-Homecare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-101"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-3",
    points: "76.97 92.6 76.97 42.16 89.73 35.65 89.73 86.18 76.97 92.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    className: "cls-7",
    points: "6 6.51 76.97 42.16 76.97 92.6 6 57.11 6 6.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "cls-4",
    points: "89.73 35.65 18.67 0 6 6.51 76.97 42.16 89.73 35.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-6",
    d: "m59.14,39.2l1.73.93v40.22l-1.73-.76v-40.39Zm4.22,2.07l1.73.93v40.22l-1.73-.76v-40.39Zm4.27,2.16l1.73.93v40.22l-1.73-.76v-40.39Zm4.22,2.07l1.73.93v40.22l-1.73-.76v-40.39Zm-29.53-14.66l1.73.93v40.22l-1.73-.76V30.84Zm4.22,2.07l1.73.93v40.22l-1.73-.76v-40.39Zm4.27,2.15l1.73.93v40.22l-1.73-.76v-40.39Zm4.22,2.07l1.73.93v40.22l-1.73-.76v-40.39Zm-29.53-14.7l1.73.93v40.22l-1.73-.76V22.43Zm-3.93-2.07l1.73.93v40.22l-1.73-.76V20.36Zm-4.14-2.07l1.73.93v40.21l-1.73-.76V18.29Zm-4.18-2.03l1.73.93v40.22l-1.73-.76V16.26Zm-4.06-2.03l1.73.93v40.22l-1.73-.76V14.24Zm20.53,10.27l1.73.93v40.22l-1.73-.76V24.5Zm4.27,2.15l1.73.93v40.22l-1.73-.76V26.66Zm4.23,2.07l1.73.93v40.22l-1.73-.76V28.73Zm38.78,15.71l-.11-.05L6,9.09v-.55l71.01,35.35,12.72-6.21v.55l-12.72,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-8",
    d: "m85.08,45.47c-.84-.3-1.91.54-2.38,1.88-.48,1.33-.18,2.66.66,2.96l1.72.74,2.32-4.37-2.32-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-2",
    d: "m92.24,47.22l-3.74-1.63c-1.43-.51-3.2.79-3.95,2.9-.75,2.11-.2,4.23,1.23,4.74l3.74,1.63c1.43.51,3.2-.79,3.95-2.9.75-2.11.2-4.24-1.23-4.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-1",
    d: "m93.46,51.96c-.75,2.11-2.52,3.41-3.95,2.9-1.43-.51-1.98-2.63-1.23-4.74.75-2.11,2.52-3.41,3.95-2.9,1.43.51,1.98,2.63,1.23,4.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "cls-8",
    d: "m84.94,34.39l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.29-1.48l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.73l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.21-1.48l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-2.85-1.52l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.34-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.17-1.69l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.34-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.69l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.34-1.56l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.91.97-9.93,5.11-2.03-.97,10.04-5.11Zm-2.85-1.48l1.92.97-9.93,5.11-2.03-.97,10.04-5.11Zm-3.13-1.56l1.92.97-9.93,5.11-2.03-.97L18.91,1.44Zm59.88,82.9v3.17s.19,1.52,1.27,1.01l7.03-3.48s.82-.44.89-2.47v-2.66s-.06-1.46-1.46-.76l-6.53,3.17s-1.2.7-1.2,2.03"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-1",
    d: "m79.53,82.68l4.39,2.36s2.47,1.16,2.41,3.59v9.91s.19,1.33-1.33,1.46c-1.52.13-1.27-1.33-1.27-1.33v-9.44s.02-1.14-.97-1.65c-.99-.51-3.97-2.18-3.97-2.18,0,0-.29-2.07.75-2.72"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-5",
    d: "m83.93,80.4l4.63,2.48s2.47,1.16,2.41,3.59v9.91s.19,1.33-1.33,1.46c-1.52.13-1.27-1.33-1.27-1.33v-9.44s.02-1.14-.97-1.65c-.99-.51-6.71-3.44-6.71-3.44,0,0,2.21-.93,3.25-1.58"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiator);
export default __webpack_public_path__ + "static/media/radiator.037ed8a0b5f13b2ab68ae1a607d87b9f.svg";
export { ForwardRef as ReactComponent };